module.exports = __webpack_public_path__ + "img/empty.ad0d2ebc.svg";